/**
 * Filtered Product Gallery Block JavaScript
 */

(function($) {
    'use strict';

    function initFilteredProductGallery() {
        const $galleries = $('.block-filtered-product-gallery');
        
        if (!$galleries.length) {
            return;
        }

        $galleries.each(function() {
            const $gallery = $(this);
            const $filterColumn = $gallery.find('.filter-column');
            const $inputs = $gallery.find('input[type="checkbox"]');
            const $activeFilters = $gallery.find('.active-filters');
            const $totalResults = $gallery.find('.total-results');
            const $noResults = $gallery.find('.no-results');
            const $blocks = $gallery.find('.gallery .block');
            const $viewMoreWrap = $gallery.find('.view-more-wrap');
            const $viewMoreBtn = $gallery.find('.view-more-btn');
            const pageSize = 9;
            let currentPage = 1;
            
            // Initialize Fancybox for active gallery items
            if (typeof $.fancybox !== 'undefined') {
                $blocks.filter('.active').fancybox({
                    buttons: [
                        "zoom",
                        "slideShow",
                        "thumbs",
                        "close"
                    ],
                });
            }

            // Show/hide filters on mobile
            $gallery.find('.show-filters').on('click', function() {
                $filterColumn.toggleClass('open');
            });

            // Reset filters
            $gallery.find('.reset').on('click', function() {
                $inputs.prop('checked', false);
                currentPage = 1;
                resetFilters();
            });

            $viewMoreBtn.on('click', function(event) {
                event.preventDefault();
                currentPage += 1;
                applyPagination();
            });

            // Handle checkbox changes
            $inputs.on('change', function() {
                const filter = $(this).data('filter');
                const $filterDiv = $(this).closest('.filter');
                const type = $filterDiv.data('filter-type');
                const $typeContainer = $('#' + type);

                if (this.checked) {
                    $typeContainer.addClass(filter);
                    $activeFilters.data('active', $activeFilters.data('active') + 1);
                } else {
                    $typeContainer.removeClass(filter);
                    $activeFilters.data('active', $activeFilters.data('active') - 1);
                }

                currentPage = 1;
                updateGallery();
            });

            function resetFilters() {
                $activeFilters.children().removeClass();
                $activeFilters.data('active', 0);
                updateGallery();
            }

            function applyPagination() {
                $blocks.removeClass('is-hidden');
                const $activeBlocks = $blocks.filter('.active');
                const totalActive = $activeBlocks.length;
                const visibleCount = currentPage * pageSize;

                $activeBlocks.each(function(index) {
                    if (index >= visibleCount) {
                        $(this).addClass('is-hidden');
                    }
                });

                if (totalActive > visibleCount) {
                    $viewMoreWrap.addClass('is-visible');
                } else {
                    $viewMoreWrap.removeClass('is-visible');
                }
            }

            function updateGallery() {
                // Hide everything first
                $blocks.removeClass('active');

                const activeCount = $activeFilters.data('active');

                if (activeCount > 0) {
                    // Start with all blocks
                    let $filtered = $blocks;

                    // Filter by each type
                    ['product_type', 'window_style', 'window_grid', 'color'].forEach(function(filterType) {
                        const $filterContainer = $('#filter-' + filterType);
                        const classes = $filterContainer.attr('class');
                        
                        if (classes && classes.trim() !== '') {
                            const selectors = '.' + classes.trim().replace(/ +/g, ', .');
                            $filtered = $filtered.filter(selectors);
                        }
                    });

                    $filtered.addClass('active');
                } else {
                    // Show everything
                    $blocks.addClass('active');
                }

                // Update results count
                const total = $blocks.filter('.active').length;
                
                if (total === 0) {
                    $totalResults.text('0 Results');
                    $noResults.addClass('active');
                    $viewMoreWrap.removeClass('is-visible');
                } else {
                    $noResults.removeClass('active');
                    if (total === 1) {
                        $totalResults.text('1 Result');
                    } else {
                        $totalResults.text(total + ' Results');
                    }
                }

                applyPagination();

                // Reinitialize Fancybox with active items only
                if (typeof $.fancybox !== 'undefined') {
                    $.fancybox.destroy();
                    $blocks.filter('.active').fancybox({
                        buttons: [
                            "zoom",
                            "slideShow",
                            "thumbs",
                            "close"
                        ],
                    });
                }
            }

            // Initial pagination state on page load
            currentPage = 1;
            applyPagination();
        });
    }

    // Initialize on document ready
    $(document).ready(function() {
        initFilteredProductGallery();
    });

    // Re-initialize on ACF block preview refresh (in editor)
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=filtered-product-gallery', function() {
            initFilteredProductGallery();
        });
    }

})(jQuery);
